const dummyFoldersSource = [
  {
    id: 1,
    name: 'Demo fleet',
    path: 0,
    parentId: 0,
    userId: 0,
    isExpanded: true,
    expanded: true,
    type: 'folder'
  },
  {
    id: 2,
    name: 'An-148',
    path: 1,
    parentId: 1,
    userId: 0,
    isExpanded: true,
    expanded: true,
    type: 'folder'
  },
  {
    id: 3,
    name: 'Mi-8',
    path: 1,
    parentId: 1,
    userId: 0,
    isExpanded: true,
    expanded: true,
    type: 'folder'
  }
];

const dummyTracksSource = [
  dummyTrack({
    id: 1001,
    recorderName: 'BUR-4-1-07',
    organization: 'Demo Air',
    startedAtFormatted: '12/03/26 08:14:22',
    vehicle: 'UR-NTA',
    name: 'PS101',
    origin: 'KBP',
    destination: 'LWO',
    parentId: 2
  }),
  dummyTrack({
    id: 1002,
    recorderName: 'BUR-4-1-07',
    organization: 'Demo Air',
    startedAtFormatted: '13/03/26 16:41:05',
    vehicle: 'UR-NTA',
    name: 'PS204',
    origin: 'LWO',
    destination: 'ODS',
    parentId: 2
  }),
  dummyTrack({
    id: 1003,
    recorderName: 'Mi-8_35_171_BUR-4-1-07',
    organization: 'Demo Helicopters',
    startedAtFormatted: '14/03/26 06:03:41',
    vehicle: 'UR-HEL',
    name: 'TRP12',
    origin: 'HRK',
    destination: 'DNK',
    parentId: 3
  }),
  dummyTrack({
    id: 1004,
    recorderName: 'Mi-8_35_171_BUR-4-1-07',
    organization: 'Demo Helicopters',
    startedAtFormatted: '15/03/26 11:28:17',
    vehicle: 'UR-HEL',
    name: 'TRP18',
    origin: 'DNK',
    destination: 'KBP',
    parentId: 3
  })
];

function dummyTrack(fields) {
  return {
    guid: 'demo-' + fields.id,
    operator: 'Demo',
    startedAt: 0,
    path: '',
    recorderId: 1,
    userId: 0,
    calibrationId: null,
    dt: null,
    noChildren: true,
    type: 'track',
    ...fields
  };
}

export function getDummyFolders() {
  return dummyFoldersSource.map((item) => ({ ...item }));
}

export function getDummyTracks() {
  return dummyTracksSource.map((item) => ({ ...item }));
}
